import React from "react";
import KickImage from 'Reuseables/KickImage';
import { Modal, Container, ModalHeader, ModalBody } from "reactstrap";
import styled from "styled-components";
import Slider from "react-slick";
import { ASSET_IMAGE, SIZE_CHART_IMAGE } from "../../../../../../../config";
import CloseIcon from "../../../../../../../images/close30.png";

/* ASSETS */

/* ===> BRANDS */
// VANS \\
import VANS_W from "../../../../../../../images/charts/vans/vans-W.png"
import VANS_M from "../../../../../../../images/charts/vans/vans-M.png"
import VANS_K from "../../../../../../../images/charts/vans/vans-K.png"

// REBOOK \\
import REBOOK_W from "../../../../../../../images/charts/rebook/rebook-W.png"
import REBOOK_M from "../../../../../../../images/charts/rebook/rebook-M.png"
import REBOOK_K from "../../../../../../../images/charts/rebook/rebook-K.png"

// PUMA \\
import PUMA_W from "../../../../../../../images/charts/puma/puma-W.png"
import PUMA_M from "../../../../../../../images/charts/puma/puma-M.png"
import PUMA_K from "../../../../../../../images/charts/puma/puma-K.png"

// NIKE \\
import NIKE_W from "../../../../../../../images/charts/nike/nike-W.png"
import NIKE_M from "../../../../../../../images/charts/nike/nike-M.png"
import NIKE_K from "../../../../../../../images/charts/nike/nike-K.png"

// NEW BALANCE \\
import NB_W from "../../../../../../../images/charts/newbalance/NB-W.png"
import NB_M from "../../../../../../../images/charts/newbalance/NB-M.png"
import NB_K from "../../../../../../../images/charts/newbalance/NB-K.png"

// CONVERSE \\
import CONVERSE_W from "../../../../../../../images/charts/converse/converse-W.png"
import CONVERSE_M from "../../../../../../../images/charts/converse/converse-M.png"
// import CONVERSE_K from "../../../../../../../images/charts/converse/converse-K.png"

// ASICS \\
import ASICS_W from "../../../../../../../images/charts/asics/asics-W.png"
import ASICS_M from "../../../../../../../images/charts/asics/asics-M.png"
import ASICS_K from "../../../../../../../images/charts/asics/asics-K.png"

// ADIDAS \\
import ADIDAS_W from "../../../../../../../images/charts/adidas/adidas-W.png"
import ADIDAS_M from "../../../../../../../images/charts/adidas/adidas-M.png"
import ADIDAS_K from "../../../../../../../images/charts/adidas/adidas-K.png"

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}></div>
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}></div>
  );
}

// const Brands = [
//   {
//     title: "NIKE",
//     name: "Nike",
//     images: [
//       {
//         URL: NIKE_M
//       },
//       {
//         URL: NIKE_W
//       },
//       {
//         URL: NIKE_K
//       }
//     ]
//   },
//   {
//     title: "ADIDAS",
//     name: "Adidas",
//     images: [
//       {
//         URL: ADIDAS_M
//       },
//       {
//         URL: ADIDAS_W
//       },
//       {
//         URL: ADIDAS_K
//       }
//     ]
//   },
//   {
//     title: "PUMA",
//     name: "Puma",
//     images: [
//       {
//         URL: PUMA_M
//       },
//       {
//         URL: PUMA_W
//       },
//       {
//         URL: PUMA_K
//       }
//     ]
//   },
//   {
//     title: "VANS",
//     name: "Vans",
//     images: [
//       {
//         URL: VANS_M
//       },
//       {
//         URL: VANS_W
//       },
//       {
//         URL: VANS_K
//       }
//     ]
//   },
//   {
//     title: "NEW BALANCE",
//     name: "New+Balance",
//     images: [
//       {
//         URL: NB_M
//       },
//       {
//         URL: NB_W
//       },
//       {
//         URL: NB_K
//       }
//     ]
//   },
//   {
//     title: "ASICS",
//     name: "Asics",
//     images: [
//       {
//         URL: ASICS_M
//       },
//       {
//         URL: ASICS_W
//       },
//       {
//         URL: ASICS_K
//       }
//     ]
//   },
//   {
//     title: "CONVERSE",
//     name: "Converse",
//     images: [
//       {
//         URL: CONVERSE_M
//       },
//       {
//         URL: CONVERSE_W
//       },
//       // {
//       //   URL: `${SIZE_CHART_IMAGE}/Converse/Converse+Kid%E2%80%99s+Shoes.png`
//       // }
//     ]
//   },
//   {
//     title: "REEBOK",
//     name: "Reebok",
//     images: [
//       {
//         URL: REBOOK_M
//       },
//       {
//         URL: REBOOK_W
//       },
//       {
//         URL: REBOOK_K
//       }
//     ]
//   }
// ];

const Brands = [
  {
    title: "NIKE",
    name: "Nike",
    images: [
      {
        URL: `${SIZE_CHART_IMAGE}/Nike/Nike+Men.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Nike/Nike+Women.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Nike/Nike+Kid.png`
      }
    ]
  },
  {
    title: "ADIDAS",
    name: "Adidas",
    images: [
      {
        URL: `${SIZE_CHART_IMAGE}/Adidas/Adidas+Men%E2%80%99s++Shoes.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Adidas/Adidas+Women%E2%80%99s++Shoes.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Adidas/Adidas+Kid%E2%80%99s+Shoes.png`
      }
    ]
  },
  {
    title: "PUMA",
    name: "Puma",
    images: [
      {
        URL: `${SIZE_CHART_IMAGE}/Puma/Puma+Men%E2%80%99s+Shoes.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Puma/Puma+Women%E2%80%99s+Shoes.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Puma/Puma+Kid%E2%80%99s+Shoes.png`
      }
    ]
  },
  {
    title: "VANS",
    name: "Vans",
    images: [
      {
        URL: `${SIZE_CHART_IMAGE}/Vans/Vans+Men%E2%80%99s+Shoes.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Vans/Vans+Women%E2%80%99s+Shoes.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Vans/Vans+Kid%E2%80%99s+Shoes.png`
      }
    ]
  },
  {
    title: "NEW BALANCE",
    name: "New+Balance",
    images: [
      {
        URL: `${SIZE_CHART_IMAGE}/New+Balance/New+Balance+Men%E2%80%99s+Shoes.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/New+Balance/New+Balance+Women%E2%80%99s+Shoes.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/New+Balance/New+Balance+Kid%E2%80%99s+Shoes.png`
      }
    ]
  },
  {
    title: "ASICS",
    name: "Asics",
    images: [
      {
        URL: `${SIZE_CHART_IMAGE}/Asics/Asics+Men%E2%80%99s+Shoes.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Asics/Asics+Women%E2%80%99s+Shoes.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Asics/Asics+Kid%E2%80%99s+Shoes.png`
      }
    ]
  },
  {
    title: "CONVERSE",
    name: "Converse",
    images: [
      {
        URL: `${SIZE_CHART_IMAGE}/Converse/Converse+Men%E2%80%99s+Shoes.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Converse/Converse+Women%E2%80%99s+Shoes.png`
      },
      // {
      //   URL: `${SIZE_CHART_IMAGE}/Converse/Converse+Kid%E2%80%99s+Shoes.png`
      // }
    ]
  },
  {
    title: "REEBOK",
    name: "Reebok",
    images: [
      {
        URL: `${SIZE_CHART_IMAGE}/Reebok/Reebook+Men%E2%80%99s+Shoes.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Reebok/Reebook+Women%E2%80%99s+Shoes.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Reebok/Reebook+Kid%E2%80%99s+Shoes.png`
      }
    ]
  },
  {
    title: "HAVAIANAS",
    name: "Havaianas",
    images: [
      {
        URL: `${SIZE_CHART_IMAGE}/Havaianas/Havaianas+Flip+Flop.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Havaianas/Havaianas+Flip+Flop+Kids.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Havaianas/Havaianas+Flip+Flop+Baby.png`
      }
    ]
  }
];

const ApparelsBrands = [
  {
    title: "NIKE",
    name: "Nike",
    images: [
      {
        URL: `${SIZE_CHART_IMAGE}/Apparels/Nike/Nike+Men%E2%80%99s.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Apparels/Nike/Nike+Women%E2%80%99s.png`
      }
    ]
  },
  {
    title: "CHAMPION",
    name: "Champion",
    images: [
      {
        URL: `${SIZE_CHART_IMAGE}/Apparels/Champion/Champion+Men%E2%80%99s.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Apparels/Champion/Champion+Women%E2%80%99s.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Apparels/Champion/Champion+Kid%E2%80%99s.png`
      }
    ]
  },
  {
    title: "UNIQLO",
    name: "Uniqlo",
    images: [
      {
        URL: `${SIZE_CHART_IMAGE}/Apparels/Uniqlo/Uniqlo+Unisex.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Apparels/Uniqlo/Uniqlo+GS.png`
      }
    ]
  },
  {
    title: "BATHING APE",
    name: "Bathing+Ape",
    images: [
      {
        URL: `${SIZE_CHART_IMAGE}/Apparels/Bathing+Ape/Bathing+Ape+Men%E2%80%99s.png`
      },
      {
        URL: `${SIZE_CHART_IMAGE}/Apparels/Bathing+Ape/Bathing+Ape+Women%E2%80%99s.png`
      }
    ]
  }
];

class ModalSizeChart extends React.Component {
  state = {
    index: 0
  };

  render() {
    const settings = {
      dots: true,
      infinite: true,
      lazyLoad: false,
      speed: 500,
      swipeToSlide: false,
      // slidesToShow: 1,
      // slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />
    };

    return (
      <Modal
        isOpen={this.props.isOpen}
        contentClassName="content-search content__filter"
        toggle={this.props.onToggle}
      >
        <Container>
          <div className="seller_modal__guide_container">
            <div
              className="seller_modal__icon_wrapper"
              onClick={this.props.onToggle}
            >
              <KickImage
                className="seller_modal__icon_close"
                src={CloseIcon}
                alt="close"
              />
            </div>
            <div className="seller_modal__wrapper">
              <div className="seller_modal__title_wrapper">
                <h5>Size Chart</h5>
              </div>
            </div>
            {this.props.category === "sneakers" ? (
              <div className="modal__wrapping__size__chart">
                <WrapperSlider className="seller_modal__wrap">
                  <Slider
                    {...settings}
                    beforeChange={(oldIndex, index) => {
                      this.setState({ index });
                    }}
                    className="seller-custom-slider"
                  >
                    {Brands &&
                      Brands.map((brand, index) => (
                        <ModalBody style={{ padding: 0 }} key={brand.name}>
                          <div style={styles.innerPadding}>
                            {brand.images &&
                              brand.images.map((image, index) => (
                                <KickImage
                                  style={{ width: "100%", maxHeight: "100%" }}
                                  src={`${image.URL}`}
                                  alt={`kickavenue ${brand.name} sizes chart`}
                                  key={brand.name}
                                />
                              ))}
                          </div>
                        </ModalBody>
                      ))}
                  </Slider>
                </WrapperSlider>
              </div>
            ) : (
              <div className="modal__wrapping__size__chart">
                <WrapperSlider className="seller_modal__wrap">
                  <Slider
                    {...settings}
                    beforeChange={(oldIndex, index) => {
                      this.setState({ index });
                    }}
                    className="seller-custom-slider"
                  >
                    {ApparelsBrands &&
                      ApparelsBrands.map((brand, index) => (
                        <ModalBody style={{ padding: 0 }} key={brand.name}>
                          <div style={styles.innerPadding}>
                            {brand.images &&
                              brand.images.map((image, index) => (
                                <KickImage
                                  style={{ width: "100%", maxHeight: "100%" }}
                                  src={image.URL}
                                  alt={`kickavenue ${brand.name} sizes chart`}
                                  key={brand.name}
                                />
                              ))}
                          </div>
                        </ModalBody>
                      ))}
                  </Slider>
                </WrapperSlider>
              </div>
            )}
          </div>
        </Container>
      </Modal>
    );
  }
}

const WrapperSlider = styled.div`
  background: #fff;
  margin: 25px;
  // height: 500px;
  overflowy: "auto" !important;
  overflowx: "hidden";
`;

// const P = styled.p`
//   font-size: 17px;
//   padding: 0 0.5rem;
//   margin: 0px;
// `;

const styles = {
  // container: {
  //   padding: '5rem 3rem',
  //   overflowY: 'hidden',
  //   overflowX: 'hidden'
  // },
  // header: {
  //   background: '#000',
  //   background: '#179953',
  //   color: '#fff',
  //   display: 'flex',
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   borderRadius: 0,
  //   padding: '1.3rem',
  //   border: 0
  // },
  innerPadding: {
    padding: 0,
    // height: '400px',
    // overflowY: 'scroll',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  }
};

export default ModalSizeChart;
